import angular from 'angular';

const oneHour = 3600;

class RequestsCache {
  constructor($q, requestsStorage, appUtils) {
    'ngInject';

    this.$q = $q;
    this.requestsStorage = requestsStorage;
    this.appUtils = appUtils;
    this.cache = {
      requests: {},
    };

    this.storage = this.requestsStorage.register('requestsCache', this.cache);
  }
  save(name, requestFn, storageTime = oneHour) {
    const request = this.getRequest(name);
    let result;
    if (!request || ((this.appUtils.timestamp() - request.time) >= storageTime)) {
      result = requestFn()
      .then((response) => {
        this._saveRequest(name, response);
        return response;
      });
    } else {
      result = this.$q.resolve(angular.copy(request.response));
    }

    return result;
  }
  getRequest(name) {
    return this.cache.requests[name];
  }
  delete() {
    this.requestsStorage.delete();
  }
  cleanAll() {
    this.storage.reset();
  }
  _saveRequest(name, response) {
    this.cache.requests[name] = {
      time: this.appUtils.timestamp(),
      response: angular.copy(response),
    };

    this.storage.update({
      requests: this.cache.requests,
    });
  }
}

export default RequestsCache;
